import * as React from 'react';
import SeparatorWrapper from './Separator.style';
import type { SeparatorProps } from './Separator.types';

const Separator = ({ color, className = '' }: SeparatorProps) => (
  <SeparatorWrapper color={color} className={className} />
);

export default Separator;
